import React from "react";
import styles from "./LoadingSelection.module.scss";

const LoadingSelection = () => {
  return (
    <div className={styles.loadingSelection}>
      <div>
        <div className={styles.loadingSelectionCircle} />
      </div>
      <div>
        <div className={styles.loadingSelectionText} />
        <div className={styles.loadingSelectionText} />
      </div>
      <div>
        <div className={styles.loadingSelectionSquare} />
      </div>
    </div>
  );
};

export default LoadingSelection;
